import React, { forwardRef } from "react";
import useSchool from "../hooks/useSchools"; // adjust path if needed


const styles = {
  page: {
    width: "210mm",
    minHeight: "297mm",
    padding: "8mm",
    fontFamily: "Arial",
    fontSize: "11px",
    lineHeight: "1.1",
    background: "#fff",
  },

  copyBlock: {
    border: "2px dashed #000",
    padding: "6mm",
    marginBottom: "6mm",
    position: "relative",
    overflow: "hidden",
  },

  headerRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "4px",
  },

  headerLeft: {
    width: "25%",
    textAlign: "left",
  },

  headerCenter: {
    width: "50%",
    textAlign: "center",
    lineHeight: "1.1",
  },

  headerRight: {
    width: "25%",
  },

  logo: {
    width: "60px",
    objectFit: "contain",
  },

  school: {
    fontSize: "16px",
    fontWeight: "bold",
    color: "red",
    marginBottom: "2px",
  },

  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "4px",
  },

  cell: {
    border: "1px solid #000",
    padding: "3px",
    fontSize: "11px",
    lineHeight: "1.1",
  },

  total: {
    fontWeight: "bold",
    background: "#eee",
  },

  footer: {
    marginTop: "10px",
    display: "flex",
    justifyContent: "space-between",
    fontSize: "11px",
  },

  watermark: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "300px",
    opacity: 0.07,
    zIndex: 0,
    pointerEvents: "none",
  },

  contentWrapper: {
    position: "relative",
    zIndex: 1,
  },

  bottomCenter: {
    marginTop: "8px",
    textAlign: "center",
    fontSize: "10px",
    fontStyle: "italic",
  },
};

// ===============================
// RECEIPT COPY
// ===============================
const ReceiptCopy = ({ data, label, school, logoUrl }) => (

  
  <div style={styles.copyBlock}>

    {/* WATERMARK */}
    {logoUrl && (
      <img
        src={logoUrl}
        alt="Watermark"
        style={styles.watermark}
      />
    )}

    <div style={styles.contentWrapper}>

      {/* HEADER */}
      <div style={styles.headerRow}>
        <div style={styles.headerLeft}>
          {logoUrl && (
            <img
              src={logoUrl}
              alt="School Logo"
              style={styles.logo}
            />
          )}
        </div>

        <div style={styles.headerCenter}>
        <div style={styles.school}>
          {school?.school_name || "School Name"}
        </div>

        <div>
          {[
            school?.school_address,
            school?.district,
            school?.state,
            school?.postal_code
          ]
            .filter(Boolean)
            .join(", ")}
        </div>

        {school?.contact_number && (
          <div>Phone: {school.contact_number}</div>
        )}

       
      </div>

        <div style={styles.headerRight}></div>
      </div>

      <div style={{ textAlign: "center", marginBottom: "4px" }}>
        ({label})
      </div>

      {/* RECEIPT INFO */}
      <table style={styles.table}>
        <tbody>
          <tr>
            <td style={styles.cell}>Receipt No</td>
            <td style={styles.cell}>{data.receipt_no}</td>
            <td style={styles.cell}>Date</td>
            <td style={styles.cell}>
              {new Date().toLocaleDateString()}
            </td>
          </tr>

          <tr>
            <td style={styles.cell}>Student</td>
            <td style={styles.cell}>{data.student_name}</td>
            <td style={styles.cell}>Class</td>
            <td style={styles.cell}>{data.class_name}</td>
          </tr>
        </tbody>
      </table>

      {/* ITEMS TABLE */}
      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.cell}>#</th>
            <th style={styles.cell}>Description</th>
            <th style={styles.cell}>Amount</th>
          </tr>
        </thead>

        <tbody>
          {data.items.map((item, i) => (
            <tr key={i}>
              <td style={styles.cell}>{i + 1}</td>
              <td style={styles.cell}>{item.fee_type}</td>
              <td style={styles.cell}>
                ₹{Number(item.amount).toFixed(2)}
              </td>
            </tr>
          ))}

          <tr>
            <td style={styles.cell}></td>
            <td style={{ ...styles.cell, ...styles.total }}>
              Total
            </td>
            <td style={{ ...styles.cell, ...styles.total }}>
              ₹{Number(data.total).toFixed(2)}
            </td>
          </tr>
        </tbody>
      </table>

      <div style={styles.footer}>
        <div>Authorized Signature</div>
        <div>Receiver Signature</div>
      </div>
      {/* 🔥 WEBSITE AT BOTTOM CENTER */}
        {school?.website_url && (
          <div style={styles.bottomCenter}>
            {school.website_url}
          </div>
        )}
    </div>
  </div>
);

// ===============================
// MAIN COMPONENT
// ===============================
const ThermalReceipt = forwardRef(({ data }, ref) => {
  const { school, logoUrl } = useSchool();

  console.log("SCHOOL:", school);
  console.log("LOGO:", logoUrl);

  if (!data) return null;

  return (
    <div ref={ref} style={styles.page}>
      <ReceiptCopy
        data={data}
        label="Client Copy"
        school={school}
        logoUrl={logoUrl}
      />

      <ReceiptCopy
        data={data}
        label="Office Copy"
        school={school}
        logoUrl={logoUrl}
      />
    </div>
  );
});

export default ThermalReceipt;